/* LMMM UX fixes (2026-11-03): require an explicit size choice and add a sticky mobile add-to-cart bar. */
(() => {
  const root = document.querySelector('product-info[id^="MainProduct-"]');
  if (!root) return;

  const SELECT_SIZE = 'Select a size';
  // A size counts as chosen once the shopper picks one, or when they land on a specific variant link.
  let sizeChosen = new URLSearchParams(window.location.search).has('variant');

  const sizeInputs = () =>
    [...root.querySelectorAll('input[type="radio"][data-option-name]')].filter(
      (input) => input.dataset.optionName.trim().toLowerCase() === 'size'
    );
  const needsSize = () => !sizeChosen && sizeInputs().length > 0;
  const mainButton = () => root.querySelector('button[name="add"]');
  const buttonLabel = (button) => button && button.querySelector(':scope > span');

  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  function sizeHint(button) {
    let hint = root.querySelector('.lmmm-size-hint');
    if (!hint && button) {
      hint = document.createElement('p');
      hint.className = 'lmmm-size-hint';
      hint.setAttribute('role', 'alert');
      hint.hidden = true;
      button.closest('.product-form__buttons').after(hint);
    }
    return hint;
  }

  function syncMainButton() {
    const button = mainButton();
    if (!button) return;
    const label = buttonLabel(button);
    if (needsSize()) {
      sizeInputs().forEach((input) => {
        if (input.checked) input.checked = false;
      });
      if (label && !button.dataset.lmmmLabel) button.dataset.lmmmLabel = label.textContent.trim();
      setText(label, SELECT_SIZE);
      if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
      button.classList.add('lmmm-needs-size');
    } else if (button.classList.contains('lmmm-needs-size')) {
      setText(label, button.dataset.lmmmLabel || label.textContent);
      button.removeAttribute('aria-disabled');
      button.classList.remove('lmmm-needs-size');
      const hint = root.querySelector('.lmmm-size-hint');
      if (hint) hint.hidden = true;
    }
  }

  function promptForSize() {
    const first = sizeInputs()[0];
    if (!first) return;
    const fieldset = first.closest('fieldset') || first.parentElement;
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const firstLabel = root.querySelector(`label[for="${first.id}"]`);
    if (firstLabel) firstLabel.focus({ preventScroll: true });
    const hint = sizeHint(mainButton());
    if (hint) {
      setText(hint, 'Pick your size first.');
      hint.hidden = false;
    }
  }

  // Runs before Dawn's own submit handler on the form, so a missing size never reaches the cart.
  document.addEventListener(
    'submit',
    (event) => {
      if (!root.contains(event.target) || !needsSize()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      promptForSize();
    },
    true
  );

  root.addEventListener('change', (event) => {
    const input = event.target;
    if (input.matches('input[type="radio"][data-option-name]') && input.dataset.optionName.trim().toLowerCase() === 'size') {
      sizeChosen = true;
      syncMainButton();
    }
  });

  /* ---- Sticky mobile add-to-cart ---- */
  const bar = document.createElement('div');
  bar.className = 'lmmm-sticky-atc';
  bar.innerHTML =
    '<div class="lmmm-sticky-atc__info"><span class="lmmm-sticky-atc__title"></span><span class="lmmm-sticky-atc__price"></span></div>' +
    '<button type="button" class="lmmm-sticky-atc__button"></button>';
  document.body.appendChild(bar);
  const barButton = bar.querySelector('.lmmm-sticky-atc__button');

  function syncBar() {
    const button = mainButton();
    const title = root.querySelector('.product__title h1');
    const price =
      root.querySelector('.price--on-sale .price-item--sale') || root.querySelector('.price__regular .price-item--regular');
    setText(bar.querySelector('.lmmm-sticky-atc__title'), title ? title.textContent.trim() : '');
    setText(bar.querySelector('.lmmm-sticky-atc__price'), price ? price.textContent.trim() : '');
    const label = buttonLabel(button);
    setText(barButton, label ? label.textContent.trim() : '');
    const soldOut = !button || button.disabled;
    barButton.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
  }

  barButton.addEventListener('click', () => {
    const button = mainButton();
    if (needsSize()) return promptForSize();
    if (button && !button.disabled) button.click();
  });

  let observedButton = null;
  const visibility = new IntersectionObserver(([entry]) => {
    const show = !entry.isIntersecting;
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('lmmm-sticky-on', show);
  });

  function watchButton() {
    const button = mainButton();
    if (button === observedButton) return;
    if (observedButton) visibility.unobserve(observedButton);
    observedButton = button;
    if (button) visibility.observe(button);
  }

  function sync() {
    syncMainButton();
    syncBar();
    watchButton();
  }

  // Dawn re-renders the product info on every variant change; re-apply after each render.
  new MutationObserver(sync).observe(root, { childList: true, subtree: true });
  sync();

  /* ---- Size guide drawer ---- */
  let drawer = null;

  function sizeGuideDrawer() {
    if (drawer) return drawer;
    const guide = document.getElementById('size-guide');
    if (!guide || typeof HTMLDialogElement === 'undefined') return null;
    drawer = document.createElement('dialog');
    drawer.className = 'lmmm-sg-drawer';
    drawer.setAttribute('aria-labelledby', 'lmmm-sg-title');
    drawer.innerHTML =
      '<div class="lmmm-sg-drawer__head"><h2 class="lmmm-sg-drawer__title" id="lmmm-sg-title">Size guide</h2>' +
      '<button type="button" class="lmmm-sg-drawer__close" aria-label="Close size guide">&times;</button></div>' +
      '<div class="lmmm-sg-drawer__body"></div>';
    // Move the guide itself so its unit toggle keeps working and the page has no duplicate ids.
    drawer.querySelector('.lmmm-sg-drawer__body').appendChild(guide);
    drawer.querySelector('.lmmm-sg-drawer__close').addEventListener('click', () => drawer.close());
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });
    document.body.appendChild(drawer);
    return drawer;
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#size-guide"]');
    if (!link) return;
    const dialog = sizeGuideDrawer();
    if (!dialog) return;
    event.preventDefault();
    dialog.showModal();
    dialog.scrollTop = 0;
  });
})();
